<template>
    <div id="app">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <QwixxNumbers>
                        <QwixxRow>
                            <QwixxNumber color="red" :number="2" />
                            <QwixxNumber color="red" :number="3" />
                            <QwixxNumber color="red" :number="4" />
                            <QwixxNumber color="red" :number="5" />
                            <QwixxNumber color="red" :number="6" />
                            <QwixxNumber color="red" :number="7" />
                            <QwixxNumber color="red" :number="8" />
                            <QwixxNumber color="red" :number="9" />
                            <QwixxNumber color="red" :number="10" />
                            <QwixxNumber color="red" :number="11" />
                            <QwixxNumber color="red" :number="12" />
                            <QwixxNumber color="red" lock />
                        </QwixxRow>
                        <QwixxRow>
                            <QwixxNumber color="yellow" :number="2" />
                            <QwixxNumber color="yellow" :number="3" />
                            <QwixxNumber color="yellow" :number="4" />
                            <QwixxNumber color="yellow" :number="5" />
                            <QwixxNumber color="yellow" :number="6" />
                            <QwixxNumber color="yellow" :number="7" />
                            <QwixxNumber color="yellow" :number="8" />
                            <QwixxNumber color="yellow" :number="9" />
                            <QwixxNumber color="yellow" :number="10" />
                            <QwixxNumber color="yellow" :number="11" />
                            <QwixxNumber color="yellow" :number="12" />
                            <QwixxNumber color="yellow" lock />
                        </QwixxRow>
                        <QwixxRow>
                            <QwixxNumber color="green" :number="12" />
                            <QwixxNumber color="green" :number="11" />
                            <QwixxNumber color="green" :number="10" />
                            <QwixxNumber color="green" :number="9" />
                            <QwixxNumber color="green" :number="8" />
                            <QwixxNumber color="green" :number="7" />
                            <QwixxNumber color="green" :number="6" />
                            <QwixxNumber color="green" :number="5" />
                            <QwixxNumber color="green" :number="4" />
                            <QwixxNumber color="green" :number="3" />
                            <QwixxNumber color="green" :number="2" />
                            <QwixxNumber color="green" lock />
                        </QwixxRow>
                        <QwixxRow>
                            <QwixxNumber color="blue" :number="12" />
                            <QwixxNumber color="blue" :number="11" />
                            <QwixxNumber color="blue" :number="10" />
                            <QwixxNumber color="blue" :number="9" />
                            <QwixxNumber color="blue" :number="8" />
                            <QwixxNumber color="blue" :number="7" />
                            <QwixxNumber color="blue" :number="6" />
                            <QwixxNumber color="blue" :number="5" />
                            <QwixxNumber color="blue" :number="4" />
                            <QwixxNumber color="blue" :number="3" />
                            <QwixxNumber color="blue" :number="2" />
                            <QwixxNumber color="blue" lock />
                        </QwixxRow>
                    </QwixxNumbers>
                </div>
                <div class="swiper-slide">
                    <QwixxNumbers>
                        <QwixxRow>
                            <QwixxNumber color="yellow" :number="2" />
                            <QwixxNumber color="yellow" :number="3" />
                            <QwixxNumber color="yellow" :number="4" />
                            <QwixxNumber color="blue" :number="5" />
                            <QwixxNumber color="blue" :number="6" />
                            <QwixxNumber color="blue" :number="7" />
                            <QwixxNumber color="green" :number="8" />
                            <QwixxNumber color="green" :number="9" />
                            <QwixxNumber color="green" :number="10" />
                            <QwixxNumber color="red" :number="11" />
                            <QwixxNumber color="red" :number="12" />
                            <QwixxNumber color="red" lock />
                        </QwixxRow>
                        <QwixxRow>
                            <QwixxNumber color="red" :number="2" />
                            <QwixxNumber color="red" :number="3" />
                            <QwixxNumber color="green" :number="4" />
                            <QwixxNumber color="green" :number="5" />
                            <QwixxNumber color="green" :number="6" />
                            <QwixxNumber color="green" :number="7" />
                            <QwixxNumber color="blue" :number="8" />
                            <QwixxNumber color="blue" :number="9" />
                            <QwixxNumber color="yellow" :number="10" />
                            <QwixxNumber color="yellow" :number="11" />
                            <QwixxNumber color="yellow" :number="12" />
                            <QwixxNumber color="yellow" lock />
                        </QwixxRow>
                        <QwixxRow>
                            <QwixxNumber color="blue" :number="12" />
                            <QwixxNumber color="blue" :number="11" />
                            <QwixxNumber color="blue" :number="10" />
                            <QwixxNumber color="yellow" :number="9" />
                            <QwixxNumber color="yellow" :number="8" />
                            <QwixxNumber color="yellow" :number="7" />
                            <QwixxNumber color="red" :number="6" />
                            <QwixxNumber color="red" :number="5" />
                            <QwixxNumber color="red" :number="4" />
                            <QwixxNumber color="green" :number="3" />
                            <QwixxNumber color="green" :number="2" />
                            <QwixxNumber color="green" lock />
                        </QwixxRow>
                        <QwixxRow>
                            <QwixxNumber color="green" :number="12" />
                            <QwixxNumber color="green" :number="11" />
                            <QwixxNumber color="red" :number="10" />
                            <QwixxNumber color="red" :number="9" />
                            <QwixxNumber color="red" :number="8" />
                            <QwixxNumber color="red" :number="7" />
                            <QwixxNumber color="yellow" :number="6" />
                            <QwixxNumber color="yellow" :number="5" />
                            <QwixxNumber color="blue" :number="4" />
                            <QwixxNumber color="blue" :number="3" />
                            <QwixxNumber color="blue" :number="2" />
                            <QwixxNumber color="blue" lock />
                        </QwixxRow>
                    </QwixxNumbers>
                </div>
            </div>
            <div class="swiper-scrollbar"></div>
        </div>
        <QwixxScore></QwixxScore>
    </div>
</template>

<script>

// import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'

import QwixxNumber from '@/components/QwixxNumber.vue'
import QwixxNumbers from '@/components/QwixxNumbers.vue'
import QwixxRow from '@/components/QwixxRow.vue'
import QwixxScore from '@/components/QwixxScore.vue'
import Swiper from 'swiper'

export default {
    name: 'app',
    components: {
        QwixxNumber,
        QwixxNumbers,
        QwixxRow,
        QwixxScore
    },
    mounted() {
        new Swiper('.swiper-container', {
            scrollbar: {
                el: '.swiper-scrollbar',
                hide: true,
            },
        });
    }
}

</script>

<style>

:root {
    --color-red: #EE2049;
    --color-yellow: #F9AA21;
    --color-green: #0CAA58;
    --color-blue: #117FCD;

    --nord0: #2e3440;
    --nord1: #3b4252;
    --nord2: #434c5e;
    --nord3: #4c566a;
    --nord4: #d8dee9;
    --nord5: #e5e9f0;
    --nord6: #eceff4;
    --nord7: #8fbcbb;
    --nord8: #88c0d0;
    --nord9: #81a1c1;
    --nord10: #5e81ac;
    --nord11: #bf616a;
    --nord12: #d08770;
    --nord13: #ebcb8b;
    --nord14: #a3be8c;
    --nord15: #b48ead;
}

html,body {
    margin: 0;
    padding: 0;
    background: #d8dee9;
}

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}


.swiper-container {
    width: 100%;
    height: 100%;
}


</style>
